"use strict"

/**
 *	----------------------------------------------------------------------------------------------
 *	Imports
 * 	----------------------------------------------------------------------------------------------
 */
import { tag, template, useShadow } from "slim-js/Decorators";
import { Slim } from "slim-js";

import { navTo, scrollToElement } from "../../../js/utils";

import TEMPLATE_HTML from './header.template.html';
import TEMPLATE_CSS from './header.styles.scss';

/**
 *	----------------------------------------------------------------------------------------------
 *	Class HeaderComponent - Module
 * 	----------------------------------------------------------------------------------------------
 */
@tag('app-header')
@template(`<style>${TEMPLATE_CSS}</style>${TEMPLATE_HTML}`)
@useShadow(true)
class AppHeader extends Slim {

	constructor(){
		super();
		this.navigateTo = navTo;
	}


	onRender(){
		
	}	
	
	changeVersion(evt){
		window.location.replace("https://adamantium-ui.minddraft.com/"+evt.target.value);
	}

}

export { AppHeader };